import store from '@state/store'
let axiosBase = require('axios')
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL')
import Vue from 'vue'

axiosBase.interceptors.response.use(function (response) {

    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
}, function (error) {

    try {
        console.error("%c⚠️ Ocurrió un error, reintente. Informe a Triduum si el problema persiste ⚠️", "color:red; font-size:16px");
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        if (error.response && error.response.data && error.response.data.error){
            const vm = new Vue()
            vm.$bvToast.toast(error.response.data.error, 
                { 
                    toast: 'error1',
                    variant: 'danger', 
                    solid: true,
                    title: error.response.data.type 
                })
        } else if (error.response && error.response.data && error.response.data.items){
            const items = error.response.data.items
            let errors = ""
            for (let index = 0; index < items.length; index++) {
                if (Object.keys(items[index]).length === 0) continue;
                const _error = items[index];
                errors += "- " + JSON.stringify(_error).replace(/[.*+:?^${}()|[\]\\]/g, '').replaceAll(/['"]+/g, ' ') + ". "; 
            }
            const vm = new Vue()
            vm.$bvToast.toast(errors, 
                {
                    toast: 'error2',
                    variant: 'danger',
                    solid: true, 
                    title: 'Error 404 - '+error.response.config.url.replace(serverUrl, ''),
                    noAutoHide: true
                })
        } else if(error.response){
            console.error(error.response)
        } else {
            console.error(error.toString())
        }
    } catch(e){
        console.error("error try", e)
    }

    return Promise.reject(error);
});

export const axios = {

    getAppCredentials() {
        return store.state.appAuth.appSession
            ? `key ${store.state.appAuth.appSession.key}` : ''
    },
    defaultOptions(options) {
        let extraOptions = {
            headers: {
                'Authorization': store.state.auth.currentSession
                    ? `key ${store.state.auth.currentSession.key}` : '',
                'Accept-Language': store.state.language.language
                    ? store.state.language.language : 'en'
            }
        }
        // appRequest makes the request auto-authenticable (no-user login required)
        // axios uses in-app-auth built-in instead
        if ('appRequest' in options && options.appRequest) {
            delete options["appRequest"];
            extraOptions.headers['Authorization'] = this.getAppCredentials()
        }
        if ('headers' in options && options.headers){
            extraOptions.headers = {
                ...extraOptions.headers,
                ...options.headers
            }
            delete options.headers            
        }
        return {
            ...extraOptions,
            ...options
        }
    },
    get(url, options = {}) { 
        return axiosBase.get(url, this.defaultOptions(options)) 
    },
    post(url, data, options = {}) { 
        return axiosBase.post(url, data, this.defaultOptions(options))
    },
    put(url, data, options = {}) { 
        return axiosBase.put(url, data, this.defaultOptions(options))
    },
    delete(url, options = {}) { 
        return axiosBase.delete(url, this.defaultOptions(options)) 
    },
}

export default axios